import {RouteRecordRaw} from "vue-router";
import RegistrationInquiryListPage from "@/modules/RegistrationInquiry/pages/RegistrationInquiryListPage.vue";
import RegistrationInquiryDetailPage from "@/modules/RegistrationInquiry/pages/RegistrationInquiryDetailPage.vue";

const registrationInquiryRoutes: Array<RouteRecordRaw> = [
  {
    path: "/registrationinquiry/list",
    component: RegistrationInquiryListPage
  },
  {
    path: "/registrationinquiry/details/:id",
    component: RegistrationInquiryDetailPage,
    props: true
  }
];

export default registrationInquiryRoutes;
